import { PenDrawingAnnotation, ScaleInfo } from "custom-models/ViewerTypes";

import { AnnotationColors } from "./subtree";
import ViewerFacade from "../ViewerFacade";

interface PenDrawingProps {
  annotation: PenDrawingAnnotation;
  scaleInfo: ScaleInfo;
  viewerFacade: ViewerFacade;
  isSelected?: boolean;
}

const PenDrawing = (props: PenDrawingProps) => {
  const scaleInfo = props.scaleInfo;
  const { pathInfo, is_diagnostic } = props.annotation;
  const { isSelected } = props;
  const color = isSelected
    ? AnnotationColors.SELECTED
    : props.annotation.id
    ? is_diagnostic
      ? AnnotationColors.DIAGNOSTIC
      : AnnotationColors.DEFAULT
    : AnnotationColors.ACTIVE;
  return (
    <path
      fill="none"
      d={pathInfo}
      stroke={color}
      strokeWidth={3 / scaleInfo.scaleX}
      vectorEffect="non-scaling-stroke"
    />
  );
};

export default PenDrawing;
